/**
 * Who a child can be ([D-158](../../../docs/DECISIONS.md#d-158), mockup 33).
 *
 * Twenty animals and eight colours, **all free**
 * ([D-036](../../../docs/DECISIONS.md#d-036)): choosing who you are is identity,
 * not a cosmetic. The colours tint the card *behind* the animal, never the fur,
 * because recolouring a panda breaks the panda.
 *
 * The bodies themselves are drawn in `@capytalk/tokens`, which the server does
 * not depend on. These lists are what the server checks a choice against, and a
 * test in the web app, which has both, fails if the two ever disagree.
 */
export const AVATAR_SPECIES = [
    'fox',
    'cat',
    'dog',
    'rabbit',
    'bear',
    'panda',
    'frog',
    'owl',
    'penguin',
    'tiger',
    'koala',
    'hedgehog',
    'otter',
    'turtle',
    'duck',
    'sheep',
    'monkey',
    'elephant',
    'deer',
    'axolotl',
];
/** The card behind the animal, in the order the picker shows them. */
export const AVATAR_BACKGROUNDS = [
    '#E08A4B',
    '#8C6A4F',
    '#D9D2C5',
    '#7FC3A8',
    '#7FA9DB',
    '#C79BD6',
    '#E8A0B0',
    '#F2C94C',
];
/** True for an animal the picker offers. */
export const isAvatarSpecies = (species) => AVATAR_SPECIES.includes(species);
/** True for a colour the picker offers. */
export const isAvatarBackground = (colour) => AVATAR_BACKGROUNDS.includes(colour);
//# sourceMappingURL=avatars.js.map